import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    list: {
      position: "relative",
      [theme.breakpoints.up("md")]: {
        flex: "auto",
        overflow: "auto"
      }
    },
    itemRoot: {
      display: "flex",
      alignItems: "center",
      padding: "4px 16px",
      borderBottom: "1px solid #eee",
      cursor: "pointer"
    },
    itemRootOdd: {
      backgroundColor: "#f6f6f6"
    },
    marker: {
      marginRight: 12,
      backgroundColor: primary.light,
      minWidth: 7,
      minHeight: 7,
      borderRadius: "50%",
      [theme.breakpoints.up("md")]: {
        marginRight: 20
      }
    },
    rowsWrapper: {
      display: "flex",
      flexWrap: "wrap",
      flexGrow: 1,
      overflow: "hidden"
    },
    rowHeader: {
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
      flexGrow: 1,
      color: primary.dark,
      fontSize: 12
    },
    notificationType: {
      color: "inherit"
    },
    rowContent: {
      wordBreak: "break-word",
      color: "#333",
      fontSize: 12,
      lineHeight: "22px",
      textTransform: "capitalize"
    },
    unread: {
      "& $notificationType": {
        color: primary.main
      },
      "& $marker": {
        backgroundColor: theme.palette.warning.dark
      }
    },
    scrollable: {
      height: "100%",
      overflowY: "auto"
    },
    loaderFetching: {
      backgroundColor: "#fff",
      position: "absolute",
      width: "100%",
      opacity: 0.5
    },
    subHeader: {
      [theme.breakpoints.down(Breakpoints.SX_720)]: {
        padding: "12px 16px"
      }
    },
    content: {
      [theme.breakpoints.down(Breakpoints.SX_720)]: {
        minHeight: 144
      }
    }
  };
});
